const layers = [
  {
    type: 'overlayers',
    name: 'Sobreposições',
    visible: true,
    layers: [
      {
        id: 21000,
        name: 'Aquíferos',
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?',
        url_params: {
          LAYERS: 'forecastdev:aquiferoaflorante',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        tooltip_params: {
          KEYS: [
            '{"key": "saanome", "label_title": ""}',
            '{"key": "saatipo", "label": "Tipo", "icon_label":"mdi-texture-box"}',
          ],
          FORMAT: '{0} ({1})',
        },
        property_params: {
          opacity: 0.8,
          visible: false,
          zindex: 1,
        },
        caption_html: {
          alwaysVisible: false,
          vertical: true,
          groupItems: [
            {
              text: 'Cárstico',
              items: [
                {
                  text: 'Carste da Bacia do Paraná',
                  color: '#F2AB43',
                  style: 'square',
                },
              ],
            },
            {
              text: 'Fraturado',
              items: [
                {
                  text: 'Fraturado Centro-Sul',
                  color: '#C0FF43',
                  style: 'square',
                },
                {text: 'Serra Geral', color: '#79BA43', style: 'square'},
              ],
            },
            {
              text: 'Poroso',
              items: [
                {
                  text: 'Alexandra - Guaraqueçaba',
                  color: '#96E6FE',
                  style: 'square',
                },
                {
                  text: 'Bateias - Campo Alegre',
                  color: '#8EDEF8',
                  style: 'square',
                },
                {text: 'Bauru-Caiuá', color: '#8CDAF6', style: 'square'},
                {text: 'Cananéia', color: '#82CFF0', style: 'square'},
                {text: 'Castro', color: '#80CDEE', style: 'square'},
                {text: 'Ervalzinho', color: '#77C1E7', style: 'square'},
                {text: 'Furnas', color: '#76BCE3', style: 'square'},
                {text: 'Guabirotuba', color: '#72B8E1', style: 'square'},
                {text: 'Guarani', color: '#74BBE3', style: 'square'},
                {text: 'Itararé', color: '#6CB2DD', style: 'square'},
                {text: 'Palermo', color: '#5EA1D2', style: 'square'},
                {text: 'Passa Dois', color: '#5A9BCE', style: 'square'},
                {text: 'Ponta Grossa', color: '#5592CB', style: 'square'},
                {text: 'Rio Bonito', color: '#508FC8', style: 'square'},
                {
                  text: 'Litorâneo Nordeste - Sudeste',
                  color: '#436EB0',
                  style: 'square',
                },
              ],
            },
          ],
        },
      },
      {
        id: 21001,
        name: 'Bacias',
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?sortby=sbsarea+d',
        url_params: {
          LAYERS: 'forecastdev:customer_subbasin',
          STYLES: 'pgw_polygon_env',
          ENV: 'stroke_color:0583F2;fill_color:FFF;stroke_width:1;fill_opacity:0.05',
          CQL_FILTER: 'bacid=16',
          VIEWPARAMS: 'customer_id:7',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        tooltip_params: {
          KEYS: ['{"key": "sbsname", "label_title": ""}'],
          FORMAT: '{0}',
          icon_params: {
            class: 'icon-infohidro-bacia',
            background_color: '#0071B0',
          },
        },
        event_params: {
          type: 'click',
        },
        property_params: {
          opacity: 1,
          visible: false,
          zindex: 1,
          highlightOnHoverFeature: {
            fillColor: 'rgba(101, 156, 213, 0.5)',
            strokeColor: '#659CD5',
          },
        },
      },
      {
        id: 21002,
        name: 'Hidrografia',
        url: 'https://produtos.simepar.br/geosimepar/shape/wms?',
        url_params: {
          LAYERS: 'shape:hidrografia_iat',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        tooltip_params: {
          KEYS: ['{"key": "nooriginal", "label_title": ""}'],
          FORMAT: '{0}',
        },
        property_params: {
          opacity: 0.8,
          visible: false,
          zindex: 3,
        },
      },
      {
        id: 21003,
        name: 'Gerências Gerais',
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?',
        url_params: {
          LAYERS: 'forecastdev:gerenciageralsanepar',
          STYLES: 'pgw_polygon_env',
          ENV: 'fill_color:0071B0;stroke_color:0071B0;fill_opacity:0.8;fill_color:FFF;fill_opacity:0.05',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        tooltip_params: {
          KEYS: [
            /* "ggsdescricao", */
            '{"key": "ggsdescricao", "label_title": ""}',
          ],
          FORMAT: '{0}',
        },
        property_params: {
          opacity: 0.8,
          visible: false,
          zindex: 2,
          highlightOnHoverFeature: {
            fillColor: 'rgba(0, 113, 176, 0.5)',
            strokeColor: '#95A1EC',
          },
        },
      },
      {
        id: 21004,
        name: 'Gerências Regionais',
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?',
        url_params: {
          LAYERS: 'forecastdev:gerenciaregionalsanepar',
          STYLES: 'pgw_polygon_env',
          ENV: 'fill_color:004870;stroke_color:004870;fill_opacity:0.8;fill_color:FFF;fill_opacity:0.05',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        tooltip_params: {
          KEYS: [
            /* "grssigla", */
            '{"key": "grssigla", "label_title": ""}',
          ],
          FORMAT: '{0}',
        },
        property_params: {
          opacity: 0.8,
          visible: false,
          zindex: 2,
          highlightOnHoverFeature: {
            fillColor: 'rgba(0, 72, 112, 0.5)',
            strokeColor: '#004870',
          },
        },
      },
      {
        id: 21005,
        name: 'Pontos de lançamento de efluentes',
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?',
        url_params: {
          LAYERS: 'forecastdev:pontoreceptor',
          STYLES: 'pgw-ete-effluent_receiving_point',
          ENV: 'circle_fill_color:FFAB7A',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        event_params: {
          type: 'click',
        },
        tooltip_params: {
          KEYS: [
            /* "rcpete",
            "citname",
            "rcpnome" */
            '{"key": "rcpete,citname,rcpnome", "label_title": "ETE"}',
          ],
          FORMAT: 'ETE {0} - {1} - {2}',
        },
        property_params: {
          opacity: 0.9,
          visible: false,
          zindex: 2,
        },
        icon_params: {
          class: 'icon-infohidro-pontos-efluentes',
          background_color: '#FFAB7A',
        },
      },
      {
        id: 21006,
        name: 'Pontos de captação',
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?',
        url_params: {
          LAYERS: 'forecastdev:pontocaptacao',
          STYLES: 'pgw-sia-catchment_point',
          ENV: 'circle_fill_color:7AC1FF',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        tooltip_params: {
          KEYS: [
            '{"key": "cptsia,citname,sistema,cptnome", "label_title": "SIA"}',
          ],
          FORMAT: 'SIA {0} - {1} - {2} - {3}',
        },
        event_params: {
          type: 'click',
        },
        property_params: {
          opacity: 0.9,
          visible: false,
          zindex: 2,
        },
        icon_params: {
          class: 'icon-infohidro-pontos-captacao',
          background_color: '#7AC1FF',
        },
      },
      {
        id: 21007,
        name: 'Sedes de Municípios',
        url: 'https://produtos.simepar.br/geosimepar/tornado/wms?',
        url_params: {
          LAYERS: 'tornado:sedemunicipalgeo',
          STYLES: 'pgw-point_building',
          CQL_FILTER: "seduf='PARANA'",
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        tooltip_params: {
          KEYS: [
            /* "nome" */
            '{"key": "nome", "label_title": ""}',
          ],
          FORMAT: '{0}',
        },
        property_params: {
          opacity: 0.8,
          visible: false,
          zindex: 4,
        },
        icon_params: {
          class: 'icon-infohidro-predio',
          background_color: '#FF7630',
        },
      },
      {
        id: 733,
        name: 'Ponto de captação e bacia de manancial',
        url: 'https://produtos.simepar.br/geobarragem/bd/wms?',
        url_params: {
          LAYERS: 'bd:group_sia',
          STYLES: 'pgw-group_sia',
          SRS: 'EPSG:4326',
          VIEWPARAMS: 'locationid:1162',
          ENV: 'circle_fill_color:3eca8f;polygon_fill_color:b1ebce;polygon_fill_opacity:0.8;polygon_stroke_color:58d09a',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 0.9,
          visible: true,
          zindex: 0,
        },
        hide_on_menu: true,
      },
      // 
      {
        id: 21008,
        name: 'Poços',
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?',
        url_params: {
          LAYERS: 'forecastdev:pocos_sanepar',
          STYLES: 'pgw-grant_wells',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        tooltip_params: {
          KEYS: [
          '{"key": "siasanepar", "label": "Código SIA"}',
          // '{"key": "coord_x,coord_y", "label": "Coordenadas"}',
          '{"key": "municipio", "label": "Município"}',
          '{"key": "localidade_saa", "label": "SAA (Localidade)"}',
          '{"key": "ushg", "label": "CodUSGH"}',
          '{"key": "cbs", "label": "Operação CSB"}',
          '{"key": "datafinalperfuracao", "label": "Data perfuração"}',
          '{"key": "profundidadefinal", "label": "Profundidade",  "suffix": "(m)"}',
          '{"key": "aquifero", "label": "Aquífero"}',

          '{"key": "separator", "label": "separator"}',

          '{"key": "vazaorecomendada", "label": "Vazão recomendada (m³/H)",  "suffix": "(m³/H)"}',
          '{"key": "crivo", "label": "Crivo",  "suffix": "(m)"}',
          '{"key": "ne", "label": "NE",  "suffix": "(m)"}',
          '{"key": "nd", "label": "ND",  "suffix": "(m)"}',
          '{"key": "ndms", "label": "NDMS",  "suffix": "(m)"}',
          '{"key": "regimebombeamento", "label": "Regime de Bombeamento",  "suffix": "(h/dia)"}',
          '{"key": "volume", "label": "Volume",  "suffix": "(m³/mês)"}',

          '{"key": "separator", "label": "separator"}',

          '{"key": "vazaooutorgada", "label": "Vazão Outorgada",  "suffix": "(m³/h)"}',
          '{"key": "vencimento", "label": "Vencimento"}',
        ],
          FORMAT: '{0}',
          icon_params: {
            class: 'icon-infohidro-poco',
            background_color: '#023373',
          },
        },
        icon_params: {
          class: 'icon-infohidro-poco',
          background_color: '#023373',
        },
        event_params: {
          type: 'click',
        },
        property_params: {
          opacity: 1,
          visible: true,
          zindex: 1,
          highlightOnHoverFeature: {
            fillColor: 'rgba(101, 156, 213, 0.5)',
            strokeColor: '#659CD5',
          },
        },
      },
    ],
  },
];

export default layers;
